import LocalizedEditorialPage from '../../../components/LocalizedEditorialPage'
import { locales, isLocale } from '../../../translations/config'
import getEditorialPage from '../../../translations/getEditorialPage'

const articles = ['guitar-string-frequency-chart', 'how-online-guitar-tuner-works', 'why-guitar-goes-out-of-tune']

export default function GuideArticle({ locale, article, editorialPage, editorialReviewedLabel }) {
  return <LocalizedEditorialPage locale={locale} slug={article} page={editorialPage} reviewedLabel={editorialReviewedLabel} />
}

export async function getStaticProps({ params }) {
  const locale = isLocale(params.lang) ? params.lang : 'en'
  return { props: { locale, article: params.article, ...getEditorialPage(locale, params.article) } }
}

export async function getStaticPaths() {
  return { paths: locales.flatMap(lang => articles.map(article => ({ params: { lang, article } }))), fallback: false }
}
